exports['Big5'] = require('./charset-recog-big5');

exports['EUC-JP'] = require('./charset-recog-euc-jp');

exports['EUC-KR'] = require('./charset-recog-euc-kr');

exports['GB18030'] = require('./charset-recog-gb-18030');

exports['Shift_JIS'] = require('./charset-recog-sjis');


//////////////////
// WEBPACK FOOTER
// ./node_modules/charset-detector/src/mbcs/index.js
// module id = 1819
// module chunks = 0